export default __webpack_public_path__ + "static/media/wa-1718-3.5d4bb1d6.jpg";